import { render, staticRenderFns } from "./ParticipantDefendant.vue?vue&type=template&id=5283ad96"
import script from "./ParticipantDefendant.vue?vue&type=script&lang=js"
export * from "./ParticipantDefendant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports